<template>
  <div class="pageInput" v-show="isShow.isPIShow">
    <div class="p-ipt" v-show="isDescShow">
      <div class="pp-wrapper">
        <div class="ppw-ani"></div>
        <div class="ppw-desc"></div>
        <input ref="inputBox" type="text" class="ppw-input" name="" maxlength="6" :value="userName" placeholder="请输入昵称" id="">
        <div class="ppw-btn" @click="submit"></div>
      </div>
    </div>
    <div class="p-desc" v-show="!isDescShow">
      <div class="pd-wrapper">
        <img src="./page-desc-para.png" class="pdw-desc" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageInput',
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      isDescShow: true,
      userName: ''
    }
  },
  methods: {
    submit () {
      window.alert = function (name) {
        let iframe = document.createElement("IFRAME");
        iframe.style.display="none";
        iframe.setAttribute("src", 'data:text/plain,');
        document.documentElement.appendChild(iframe);
        window.frames[0].window.alert(name);
        iframe.parentNode.removeChild(iframe);
      }
      // this.$emit('hvDirective', {name: 'm06'});
      if (this.userName) {
        this.goToFn();
        console.log(this.userName);
      } else {
        alert('请输入您的昵称')
      }
    },
    goToFn () {
      this.$emit('sendName', this.userName);
      this.isShow.isPIShow = false;
      this.isShow.isPTShow = true;
    },
    handleSelect () {
      const box = this.$refs.inputBox;
      const _this = this;
      const URL = '/codes/jiandou/game.php/Home/Words/JDOU_words/';

      box.onblur = function () {
        let gotVal = box.value;
        const _data = {
          text: gotVal
        }
        $.ajax({
          url: URL,
          type: 'POST',
          data: _data,
          dataType: 'json',
          success: function (json) {
            let msg = json.msg;
            _this.userName = msg;
          },
          error: function (err) {
            throw new Error('请求出错', err);
          }
        });
      }
    }
  },
  mounted () {
    this.handleSelect();
  }
}
</script>

<style lang="less" scoped>
.pageInput {
  height: 100%;
  .p-ipt {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-image: url('./ipt-bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    .pp-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      .ppw-ani {
        width: 14.1875rem /* 227/16 */;
        height: 12.75rem /* 204/16 */;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('./ipt-com.png');
      }
      .ppw-desc {
        margin: 2.5rem /* 40/16 */ 0 3.125rem /* 50/16 */;
        width: 16.375rem /* 262/16 */;
        height: 4.75rem /* 76/16 */;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('./ipt-desc.png');
      }
      .ppw-input {
        width: 12.8125rem /* 205/16 */;
        height: 2.5rem /* 40/16 */;
        background-color: #393d97;
        border: 1px solid #3986be;
        border-radius: .25rem /* 4/16 */;
        text-align: center;
        color: #6bf9fb;
        box-shadow: inset 1px 1px 8px #3986be, inset -1px -1px 8px #3986be;
        &::placeholder {
          color: #6bf9fb;
        }
      }
      .ppw-btn {
        margin-top: 1.875rem /* 30/16 */;
        width: 10.375rem /* 166/16 */;
        height: 2.8125rem /* 45/16 */;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('./ipt-btn.png');
      }
    }
  }
  .p-desc {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-image: url('./hw-desc-bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    .pd-wrapper {
      width: 22.25rem /* 356/16 */;
      height: 30.6875rem /* 491/16 */;
      background-image: url('./page-desc-box.png');
      background-size: cover;
      background-repeat: no-repeat;
      .pdw-desc {
        margin: 3.125rem /* 50/16 */;
        width: 16.375rem /* 262/16 */;
      }
    }
  }
}
</style>
